import React, { useEffect, useState } from "react";
import api from "../../../api";
import { useToast } from "../../../components/toast/toast";
import { Button, Flex, Table } from "antd";
import CustomHeader from "../../../components/header/CustomHeader";
import { IconPlus } from "@tabler/icons-react";
import ConfirmModal from "../../../components/modal/ConfirmModal";
import CustomModal from "../../../components/modal/CustomModal";
import CustomInput from "../../../components/input/CustomInput";
import CustomSelect from "../../../components/select/CustomSelect";

const Bank = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(null);
  const [selectedBank, setSelectedBank] = useState("");
  const [accountNumber, setAccountNumber] = useState("");

  const toast = useToast();

  const fetchList = async () => {
    setIsLoading(true);
    const res = await api.get_bank_list();
    // console.log("bank res --->", res);

    if (res.status === 200) {
      setList(res.data.data);
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const reset = () => {
    setShowModal(false);
    setSelectedBank("");
    setAccountNumber("");
  };

  const submitHandler = async () => {
    const res = await api.create_bank({
      account_number: accountNumber,
      bank: selectedBank,
    });
    // console.log("create res --->", res);
    if (res.status === 201) {
      toast("Амжилттай үүслээ", "success");
      reset();
      fetchList();
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
  };

  const deleteHandler = async (account_number) => {
    const res = await api.delete_bank({ account_number });
    // console.log("delete res", res);
    if (res.status === 200) {
      toast("Амжилттай устгагдлаа", "success");
      setVisible(false);
      fetchList();
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
  };

  const columns = [
    {
      title: "Банкны нэр",
      dataIndex: "bank",
      key: "bank",
    },
    {
      title: "Дансны дугаар",
      dataIndex: "account_number",
      key: "account_number",
    },
    {
      title: "Холбосон сугалаа",
      dataIndex: "lottery_prefix",
      key: "lottery_prefix",
      render: (val) => val || "-",
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 150,
      render: (_, record) => (
        <Button
          type="link"
          danger
          onClick={() => {
            setSelected(record.account_number);
            setVisible(true);
          }}
          style={{ fontSize: "13px" }}
        >
          Устгах
        </Button>
      ),
    },
  ];

  return (
    <Flex vertical>
      <CustomHeader
        title={"Банкны жагсаалт"}
        rightSide={
          <Button
            type="primary"
            style={{ padding: "0 30px" }}
            onClick={() => setShowModal(true)}
          >
            <IconPlus size={16} /> Данс үүсгэх
          </Button>
        }
      />

      <Table
        columns={columns}
        rowKey="account_number"
        dataSource={list}
        loading={isLoading}
      />

      <ConfirmModal
        variant="warning"
        showModal={visible}
        setShowModal={setVisible}
        submitHandler={() => deleteHandler(selected)}
        title="Итгэлтэй байна уу?"
        // description={"'Устгах' үйлдэл нь буцаах боломжгүйг анхаарна уу!"}
        description={
          <>
            '<span style={{ fontWeight: 600, color: "#0066cc" }}>Устгах</span>'
            үйлдэл нь буцаах боломжгүйг анхаарна уу!
          </>
        }
      />

      <CustomModal
        title={"Данс үүсгэх"}
        open={showModal}
        onCancel={() => reset()}
        onOk={submitHandler}
        disabled={!isLoading && selectedBank && accountNumber ? false : true}
      >
        <Flex vertical gap={"10px"}>
          <CustomSelect
            required
            title="Банк сонгох"
            value={selectedBank}
            onChange={(val) => setSelectedBank(val)}
            options={[
              { label: "Хаан банк", value: "khanbank" },
              //   { label: "Голомт банк", value: "Golomt Bank" },
              //   { label: "Худалдаа хөгжлийн банк", value: "TDB" },
              //   { label: "Хас банк", value: "Xac Bank" },
              //   { label: "Төрийн банк", value: "State Bank" },
              //   { label: "Капитрон банк", value: "Capitron Bank" },
              //   { label: "Чингис хаан банк", value: "Chingis Khan Bank" },
              //   { label: "Ариг банк", value: "Arig Bank" },
              //   {
              //     label: "Улаанбаатар хотын банк",
              //     value: "Ulaanbaatar City Bank",
              //   },
              //   { label: "Богд банк", value: "Bogd Bank" },
            ]}
          />
          <CustomInput
            required
            title={"Дансны дугаар"}
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            onKeyDown={(e) => {
              if (selectedBank && accountNumber && e.key === "Enter") {
                submitHandler();
              }
            }}
          />
        </Flex>
      </CustomModal>
    </Flex>
  );
};

export default Bank;
